// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IChangeUserLockingRequest
 */
export interface IChangeUserLockingRequest {
    /**
     * 
     * @type {number}
     * @memberof IChangeUserLockingRequest
     */
    employee_id: number;
}

/**
 * Check if a given object implements the IChangeUserLockingRequest interface.
 */
export function instanceOfIChangeUserLockingRequest(value: object): value is IChangeUserLockingRequest {
    if (!('employee_id' in value) || value['employee_id'] === undefined) return false;
    return true;
}

export function IChangeUserLockingRequestFromJSON(json: any): IChangeUserLockingRequest {
    return IChangeUserLockingRequestFromJSONTyped(json, false);
}

export function IChangeUserLockingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): IChangeUserLockingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'],
    };
}

export function IChangeUserLockingRequestToJSON(json: any): IChangeUserLockingRequest {
    return IChangeUserLockingRequestToJSONTyped(json, false);
}

export function IChangeUserLockingRequestToJSONTyped(value?: IChangeUserLockingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
    };
}

